<template>
    <div id="container" type="vmarket-trends">
        <div class="page page-market-trends" v-ga:page="{pageType:'vmarket-trends', glb: glb}">
            <mvtHeader :geoInfo="geo"/>
            <staticWelcomeSearch v-if="isHomePage || isStatePage" :title="title" :searchType="'Market Trends'" />
            <mvtPageMenu :menuType="'Market Trends'" v-if="isHomePage || isStatePage" />
            <marketTrendsBreadcrumb id="marketBreadcrumbPanel" :breadCrumb="market.breadcrumb" />
            <section v-if="isHomePage">
              <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
                <mvtCollapsibleLinks
                    title="Browse market trends by state"
                    titleClass="f3 text-capitalize text-bold p-y-2"
                    :links='homePageLinks'
                    :initialExpandedState="true"
                />
              </div>
            </section>
            <section v-else-if="isStatePage">
              <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
                <mvtCollapsibleLinks
                    :title="getTitle"
                    titleClass="f3 text-capitalize text-bold p-y-2"
                    :links='generateCityLinks'
                    :initialExpandedState="true"
                />
              </div>
            </section>
            <div v-else>
                <div class="market-trends-detail">
                    <div class="static-gs market-summary-panel" id="marketSummaryPanel">
                        <div id="summaryText">
                            <h1 class="title">{{ market.pageTitle }}, Market Trends</h1>
                            <ul class="page-summary" :class="{'hide-list': !showAllSummary }" v-html="market.pageSummary" />
                            <a role="button" class="see-all summary-show f5" @click="togglePageSummary"
                                >{{`Show ${showAllSummary ? 'Less ' : 'More '}`}}<i class="f7" :class="{'icon-angle-up':showAllSummary , 'icon-angle-down':!showAllSummary}"></i
                            ></a>
                        </div>
                    </div>
                    <section class="static-gs gs-md-2 w-full market-summary-panel" id="marketSummaryPanel">
                        <div class="static-gs market-trends-map-container" id="summaryMap">
                            <mvtLazyload>
                                <div class="markettrends-map">
                                    <mvtMapStatic class="img" :lat="geo.lat" :lng="geo.lng" zoom="11" type="roadmap" :address="geo.formatAddress"> </mvtMapStatic>
                                </div>
                            </mvtLazyload>
                            <a :href="getButtonDetails.url" class="btn primary regular w-100">{{ getButtonDetails.text }}</a>
                        </div>
                    </section>
                    <section class="grid fixed xs-grid-cols-1" v-if="market.overViewInfo" id="marketOverviewPanel">
                        <h2 class="title">{{ market.zipCodeInfo ? market.zipCodeInfo.displayName : market.cityInfo ? market.cityInfo.displayName : '' }} Overview</h2>
                        <cardSection :data="market.overViewInfo"></cardSection>
                    </section>
                    <section class="grid fixed xs-grid-cols-1" id="marketStatisticsPanel" v-if="market.marketTrendsSnapshot">
                        <div v-if="market.statistics">
                            <div class="title">
                                {{ market.statistics.title }}
                                <div class="lastUpdatedDate">{{ lastUpdatedDate }}</div>
                            </div>
                        </div>
                        <template v-if="showMarketSnapShot">
                            <div class="marketSnapShot">
                                <div v-if="market.marketTrendsSnapshot && market.marketTrendsSnapshot.length">
                                    <marketTrendsTabs @updateMetric="updateMetric">
                                        <marketTrendsTab
                                            ref="items"
                                            :hasOneMonthData="hasOneMonthData"
                                            :filterType="selectedMarketTrend"
                                            :data="{metric:selectedMetric}"
                                            @updateMarketTrend="updateMarketTrend"
                                        >
                                        </marketTrendsTab>
                                    </marketTrendsTabs>
                                    <div class="key-insight" v-if="selectedMetric && selectedMetric.paragraphics">
                                        <span class="insight-title"
                                            ><img :src="glb.cdnUrl + 'vimages/key-insight.png' " />
                                            <p>Key Insights</p></span
                                        >
                                        <div v-html="selectedMetric.paragraphics"></div>
                                        <br v-if="selectedMetric.sub_paragraphics" />
                                        <div v-if="selectedMetric.sub_paragraphics" v-html="selectedMetric.sub_paragraphics"></div>
                                    </div>
                                </div>
                                <div class="markettrends-schoolcard-noresult" v-else><i class="icon-search f1"></i> No Results</div>
                            </div>

                            <div class="compare">
                                <h2 class="title">Compare Nearby {{ market.compareLabel }}</h2>
                                <marketTrendsTabs @updateMetric="selectedMetricForNearby = $event">
                                    <div class="compare-nearby">
                                        <div class="compareCityFields">
                                            <marketTrendsDropdown :options="market.allCompares" :selectedItem="selectedCity" @changed="updateSelectedCity"></marketTrendsDropdown>
                                            <marketTrendsDropdown :options="marketTrendTypes" :selectedItem="selectedMarketTrendForNearby" @changed="updatedSelectedFilter"></marketTrendsDropdown>
                                        </div>
                                        <div class="grid fixed xs-grid-cols-1 sm-grid-cols-4 m-b-2" v-if="hasOneMonthData">
                                            <marketTrendsTabHeader
                                                v-if="getMetricForComparable"
                                                :tabHeader="getMetricForComparable"
                                                :city="{name: market.blueDisplayName, color: '#00a5d6' }"
                                            ></marketTrendsTabHeader>
                                            <marketTrendsTabHeader
                                                v-if="headerDataComparable"
                                                :tabHeader="headerDataComparable"
                                                :city="{name: selectedCity.name, color: '#FBC02D' }"
                                            ></marketTrendsTabHeader>
                                        </div>
                                        <div class="chart-container m-t-2">
                                            <marketTrendsChart
                                                :filterType="getSelectedMarketTrendForNearby"
                                                :metricDetail="getSelectedMetricForNearby"
                                                :comparedCity="getSelectedCity"
                                                :isCompareCity="true"
                                                :selectedTimePeriod="'L2Y'"
                                                @headerData="updateHeaderData"
                                            ></marketTrendsChart>
                                        </div>
                                    </div>
                                </marketTrendsTabs>
                            </div>
                        </template>
                        <a role="button" v-if="showToggleLinks" class="see-all link f5" @click="toggleMarketSnapshot"
                            >{{ getSummaryToggleText }}<i class="f7" :class="{'icon-angle-up':showAllDemo , 'icon-angle-down':!showAllDemo}"></i
                        ></a>
                    </section>

                    <section class="grid fixed xs-grid-cols-1" v-if="market.demographics_model" id="marketDemographicsPanel">
                        <h2 class="title">{{ market.demographics_model.title }}</h2>
                        <marketTrendsOverview v-if="showAllDemo" :data="market.demographics_model.initialView" :paragraphics="market.demographics_model.paragraphics"></marketTrendsOverview>

                        <div v-if="showAllDemo && market.demographics_model.subView">
                            <div v-for="section in market.demographics_model.subView">
                                <template v-if="section.charts && section.charts.length">
                                    <h2 v-if="section.title" class="title">{{ section.title }}</h2>
                                    <marketTrendsOverview :data="chart" v-for="chart in section.charts" :key="i"></marketTrendsOverview>
                                </template>
                            </div>
                        </div>
                        <a role="button" v-if="showToggleLinks" class="see-all link f5" @click="toggleDemographics"
                            >{{ getDemoToggleText }}<i class="f7" :class="{'icon-angle-up':showAllDemo , 'icon-angle-down':!showAllDemo}"></i
                        ></a>
                    </section>

                    <section class="grid fixed xs-grid-cols-1" id="marketSchoolsPanel">
                        <div v-if="market.nearbySchools && market.nearbySchools.totalCount">
                            <h2 class="title">Schools in {{ market.pageTitle }}</h2>
                            <p>{{ market.nearbySchools.title }}</p>
                            <cardSection :data="getSchoolData"></cardSection>
                            <ul class="tab tab-bookmark">
                                <li><span>Grades: </span></li>
                                <template v-for="item in market.nearbySchools.types">
                                    <li v-if="item.list && item.list.length">
                                        <a role="button" @click="toggleSchoolType(item.type)" :class="{active: schoolTypeSelected == item.type}">{{ item.type }}</a>
                                    </li>
                                </template>
                            </ul>
                        </div>
                        <div class="list-card">
                            <mvtShifter ref="shifter" v-if="getSchools && getSchools.length">
                                <mvtCardSchool v-for="school in getSchools" :data="school" :key="school.uId" :options="schoolCardOptions"></mvtCardSchool>
                            </mvtShifter>
                        </div>
                    </section>
                    <section class="grid fixed xs-grid-cols-1 schoolDistLinks" v-if="market.schoolDistricts && market.schoolDistricts.length">
                        <mvtListLinks :title="'Browse School Districts'" :links="getSchoolDistrictsLinks">
                            <a role="button" v-if="market.schoolDistricts.length > 9" class="see-all link f5" @click="toggleSchoolDistricts"
                                >{{ getSchoolDistrictsToggleText }}<i class="f7" :class="{'icon-angle-up':showAllSchoolDistricts , 'icon-angle-down':!showAllSchoolDistricts}"></i
                            ></a>
                        </mvtListLinks>
                    </section>
                    <section class="grid fixed xs-grid-cols-1" v-if="getLocalHighlight && getLocalHighlight.length" id="marketInsightsPanel">
                        <h2 class="title">{{ market.pageTitle }} Property Insights</h2>
                        <mvtLocalHighlight :localHighlight="getLocalHighlight" :max="8" />
                    </section>
                    <section class="grid fixed xs-grid-cols-1 neighborhood-scores" v-if="getLocalHighlightScore" id="marketScoresPanel">
                        <h2 class="title">{{ market.pageTitle }} Neighborhood Scores</h2>
                        <mvtLocalHighlightScore :localHighlightScore="getLocalHighlightScore" />
                    </section>
                    <section class="grid fixed xs-grid-cols-1" id="marketNewlistingsPanel" v-if="getShowList('new', geoInfoForListings('new').geoInfoType)">
                        <div class="title">
                            <a :href="glb.appUrl + geo.newPath " class="link">Recently Listed Homes in {{ geoInfoForListings('new').title }}</a>
                        </div>
                        <div class="panel">
                            <mvtLazyload ref="lazyloadnew" :async="true" data-role="propertycard">
                                <mvtNearby :type="geoInfoForListings('new').geoInfoType" filterPath="/new-7/" @completed="completed('new')" carousalType="new"></mvtNearby>
                            </mvtLazyload>
                        </div>
                    </section>
                    <section class="grid fixed xs-grid-cols-1" id="marketOpenhousesPanel" v-if="getShowList('open', geoInfoForListings('open').geoInfoType)">
                        <div class="title">
                            <a :href="glb.appUrl + geo.openHousePath " class="link">Open Houses in {{ geoInfoForListings('open').title }}</a>
                        </div>
                        <div class="panel">
                            <mvtLazyload ref="lazyloadopen" :async="true" data-role="propertycard">
                                <mvtNearby :type="geoInfoForListings('open').geoInfoType" filterPath="/open-houses/"  @completed="completed('open')" carousalType="open_house"></mvtNearby>
                            </mvtLazyload>
                        </div>
                    </section>
                    <section class="grid fixed xs-grid-cols-1" id="marketNearbypropsPanel" v-if="market.nearbyHomes && market.nearbyHomes.length">
                        <div class="title">Nearby Properties</div>
                        <div class="panel">
                            <mvtLazyload data-role="propertycard">
                                <mvtListProperty :data="listingData"></mvtListProperty>
                            </mvtLazyload>
                        </div>
                    </section>
                    <section class="grid fixed xs-grid-cols-1" v-if="market.recentArticlesData && market.recentArticlesData.articles && market.recentArticlesData.articles.length" id="marketArticles">
                        <h2 class="title">{{ market.recentArticlesData.title }}</h2>
                        <marketTrendsArticleCard theme="large" :articles="market.recentArticlesData.articles" />
                    </section>
                    <section class="grid fixed xs-grid-cols-1" id="marketSeolinksPanel" v-if="market.seoLinks">
                        <div class="panel">
                            <h2 class="h4 text-bold">{{ molang('search.common.nearbyRealEstate') }}</h2>
                            <mvtSeoLink :cities="market.seoLinks.cities" :zipcodes="market.seoLinks.zipcodes" :neighborhoods="market.seoLinks.neighborhoods" :counties="market.seoLinks.counties" />
                        </div>
                    </section>
                </div>
            </div>
            <mvtFooter :geoInfo="geo"/>
        </div>
        <mvtPopSignin />
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-market-trends.js"></script>



<style lang="scss">
    @use './page-market-trends.scss' as *;
</style>


